import { QueryClient } from '@tanstack/react-query'

export const makeAiAnalysisQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false
      }
    }
  })
